const validate = values => {
	const errors = {}
	if (!values.winecellar_name) {
		errors.winecellar_name = 'Este campo es obligatorio'
	}
	if (!values.winecellar_number_institution) {
		errors.winecellar_number_institution = 'Este campo es obligatorio'
	}
	if (!values.winecellar_address) {
		errors.winecellar_address = 'Este campo es obligatorio'
	}
	if (!values.winecellar_cuil) {
		errors.winecellar_cuil = 'Este campo es obligatorio'
	}
	if (!values.winecellar_area_code) {
		errors.winecellar_area_code = 'Este campo es obligatorio'
	}
	if (!values.winecellar_number) {
		errors.winecellar_number = 'Este campo es obligatorio'
	}
	return errors
}

export default validate


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsWinecellarForm.js
 **/